import React from 'react'
import { getLanguage } from 'react-multi-lang'
import { get } from '../utils/httpAgent'

class FooterDownloadComponent extends React.Component {
  constructor () {
    super()
    this.input = {}
    this.state = {
      link: ''
    }
    this.fetchData = this.fetchData.bind(this)
  }

  componentDidMount () {
    this.fetchData(this.getOS())
    if (this.input.name) {
      this.input.name.focus()
    }
  }

  getOS () {
    const userAgent = window.navigator.userAgent
    const platform = window.navigator.platform
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']
    let os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'macos'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'ios'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'windows'
    } else if (/Android/.test(userAgent)) {
      os = 'android'
    } else if (!os && /Linux/.test(platform)) {
      os = 'linux'
    }

    return os
  }

  fetchData (os) {
    get('https://studio-admin.cupola360.com/1/versions?company=5f98e0d7dd1fe378f8197cfb')
      .then(r => {
        if (r.success) {
          for (let i = 0; i < r.data.length; i++) {
            if (r.data[i].os === os && r.data[i].weight >= 200000 && r.data[i].isActive && r.data[i].isPublic) {
              if (r.data[i].url) {
                this.setState({
                  link: r.data[i].url
                })
              } else if (r.data[i].uri) {
                this.setState({
                  link: `https://studio-storage.cupola360.com/${r.data[i].uri}`
                })
              }
            }
          }
        }
      })
  }

  render () {
    const { t } = this.props
    const langPath = getLanguage() === 'en' ? '' : '/tw'
    return (
      <section id='slogan'>
        <div className='container text-center'>
          <h1>
            {t('slogan')}
          </h1>
          <a className='btn btn-solid mr-4' href={this.state.link ? this.state.link : `${langPath}/download`}>{t('free_download')}</a>
          <a className='btn btn-outline' href={`${langPath}/pricing`}>{t('pricing_plans')}</a>
        </div>
      </section>
    )
  }
}

export default FooterDownloadComponent
